import { render, staticRenderFns } from "./PartsTotals.vue?vue&type=template&id=4ddd8619&scoped=true"
import script from "./PartsTotals.vue?vue&type=script&lang=js"
export * from "./PartsTotals.vue?vue&type=script&lang=js"
import style0 from "./PartsTotals.vue?vue&type=style&index=0&id=4ddd8619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd8619",
  null
  
)

export default component.exports